export enum IconColor {
  DARK = 'dark',
  INHERIT = 'inherit',
  LIGHT = 'light',
  MID = 'mid',
  PRIMARY = 'primary',
  WHITE = 'white',
  CONTEST = 'contest',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  RECRUITER_LIGHT = 'recruiter-light',
  PINK = 'pink',
  SEAFOAM = 'seafoam',
  AQUA_LIGHT = 'aqua-light',
  BLUE_XDARK = 'blue-xdark',
}

export enum HoverColor {
  CURRENT = 'currentColor',
  DARK = 'dark',
  LIGHT = 'light',
  PRIMARY = 'primary',
}

export enum IconSize {
  XXLARGE = 'xxlarge',
  XLARGE = 'xlarge',
  LARGE = 'large',
  MID = 'mid',
  SMALL = 'small',
  XSMALL = 'xsmall',
}

export enum IconBackdrop {
  PRIMARY = 'primary',
  PINK = 'pink',
  ERROR = 'error',
  DARK = 'dark',
  PINK_XLIGHT = 'pink-xlight',
  AQUA_LIGHT = 'aqua-light',
  SUCCESS = 'success',
  ORANGE_XXXLIGHT = 'orange-xxxlight',
  WHITE = 'white',
  TRANSPARENT = 'transparent',
}

export enum IconBackdropStyle {
  SOLID = 'solid',
  PULSE = 'pulse',
  TRANSPARENT = 'transparent',
}

export enum IconBackdropSize {
  LARGE = 'large',
  MID = 'mid',
  SMALL = 'small',
  XSMALL = 'xsmall',
  XXSMALL = 'xxsmall',
  XXXSMALL = 'xxxsmall',
}
